import React, { useState } from 'react';
import { HorizontalToggleButtons } from '../Components/HorizontalToggleButtons';
import { ProfileCard } from '../Components/ProfileCard'

export function ProfileSection() {
	const [activeId, setActiveId] = useState('skills');

	const contentMap = {
		skills: {
			image: "/Images/Skills.png",
			data: [
				{ type: 'header', content: 'Development' },
				{ type: 'text', content: 'C#, Lua, Unity, Roblox Studio, HTML, CSS' },
				{ type: 'header', content: 'Design' },
				{ type: 'text', content: 'UI/UX Design, Figma, Photoshop, Adobe XD' }
			]
		},
		education: {
			image: "/Images/DegreeNoFrame.png",
			data: [
				{ type: 'header', content: 'Bachelor of Arts' },
				{ type: 'text', content: 'in' },
				{ type: 'header', content: 'Game Design', highlight: true },
				{ type: 'text', content: 'from' },
				{ type: 'header', content: 'Technological University Dublin' },
				{ type: 'text', content: 'with' },
				{ type: 'header', content: 'Second Class Honours, First Division' }
			]
		},
		achievements: {
			image: "/Images/Trophy.JPEG",
			data: [
				{ type: 'header', content: 'Tilt Trophy' },
				{
					type: 'text', content: (
						<>
							In 2021 I was awarded a Tilt Trophy from Roblox for players spending
							over 40 million hours in total on my game{' '}
							<a href="https://www.roblox.com/games/3093229294/Animations-Mocap"
								target="_blank"
								rel="noreferrer"
								className="game-link">Animations: Mocap</a>."
						</>
					)
				}
			]
		}
	};

	const categories = Object.keys(contentMap).map(key => ({
		id: key,
		label: key.charAt(0).toUpperCase() + key.slice(1),
		action: () => setActiveId(key)
	}));

	return (
		<div className="container">
			<HorizontalToggleButtons categories={categories} />
			<ProfileCard
				items={contentMap[activeId].data}
				image={contentMap[activeId].image}
				activeId={activeId}
				alignment='center'
			/>
		</div>
	);
}